export const VOLUNTEERING = "VOLUNTEERING";

export const CUSTOMER_SERVICES = "CUSTOMER_SERVICES";

export const CONTRACTS = "CONTRACTS";

export const GETTING_TO_US = "GETTING_TO_US";

export const ROLE ='ORGANIZATION_ADMIN'
